import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ReferralsCreate } from './ReferralsCreate';
import { ReferralsEdit } from './ReferralsEdit';
import { ReferralsList } from './ReferralsList';
import { ReferralsShow } from './ReferralsShow/ReferralsShow';

export const referralsResource: ResourceProps = {
  name: Resources.Referrals,
  create: ReferralsCreate,
  edit: ReferralsEdit,
  list: ReferralsList,
  show: ReferralsShow,
};
